import { BoxProps } from "@mui/material";
import { Box, CsiImage, Text } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";
import imageLS from "./LandscapeSmallImage.jpg";
import imageLT from "./LandscapeThumbnail.jpg";
import imagePS from "./PortraitSmallImage.jpg";
import imagePT from "./PortraitThumbnail.jpg";

const LandscapeBox = (props: BoxProps) => (
	<Box
		bgcolor="grey.200"
		border={STANDARD_BORDER_STYLE}
		display="inline-block"
		height={200}
		width={350}
		{...props}
	/>
);

const PortraitBox = (props: BoxProps) => (
	<Box
		bgcolor="grey.200"
		border={STANDARD_BORDER_STYLE}
		display="inline-block"
		height={350}
		width={200}
		{...props}
	/>
);

export default () => {
	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="small landscape (landscape container)" />
			<Text semiBold text="small portrait (landscape container)" />
			<LandscapeBox>
				<CsiImage src={imageLT} />
			</LandscapeBox>
			<LandscapeBox>
				<CsiImage src={imagePT} />
			</LandscapeBox>
			<Text semiBold text="large landscape (landscape container)" />
			<Text semiBold text="large portrait (landscape container)" />
			<LandscapeBox>
				<CsiImage src={imageLS} />
			</LandscapeBox>
			<LandscapeBox>
				<CsiImage src={imagePS} />
			</LandscapeBox>
			<Text semiBold text="small landscape (portrait container)" />
			<Text semiBold text="small portrait (portrait container)" />
			<PortraitBox>
				<CsiImage src={imageLT} />
			</PortraitBox>
			<PortraitBox>
				<CsiImage src={imagePT} />
			</PortraitBox>
			<Text semiBold text="large landscape (portrait container)" />
			<Text semiBold text="large portrait (portrait container)" />
			<PortraitBox>
				<CsiImage src={imageLS} />
			</PortraitBox>
			<PortraitBox>
				<CsiImage src={imagePS} />
			</PortraitBox>
		</CssColumnGrid>
	);
};